import React, { useState, useEffect, useRef } from "react";
import { Modal } from "./Modal";
import "./AddSourceModal.css";
import { graphql, createFragmentContainer } from "react-relay";
import InlineNotification from "./InlineNotification";
import AddSubscriptionMutation from "../mutations/AddSubscriptionMutation";
import AddSmallScreenSubMutation from "../mutations/AddSmallScreenSubMutation";
import { useTheme } from "../contexts/ThemeContext";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { useMediaQuery } from "react-responsive";
import AddFolderMutation from "../mutations/AddFolderMutation";
import ButtonSelect from "../components/ButtonSelect";
import { Add20 } from "@carbon/icons-react";

function AddSourceModal(props) {
    const [isNewFolder, setIsNewFolder] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");
    const [selectedParentId, setSelectedParentId] = useState("");
    const [selectedFolder, setSelectedFolder] = useState("");
    const [enteredFolderName, setEnteredFolderName] = useState("");

    const selectedSubId = props.selectedSubId;
    const selectedSubName = props.selectedSubName;

    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const [style, setStyle] = useState({
        modal: {
            width: "24rem",
            height: "auto",
        },
        newTextBox: {
            display: "block",
        },
    });

    const user_Subscription = props.user_Subscription;
    const theme = useTheme();

    const { isAddSourceModalActivated } = props.settings;

    function onCancelClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode == 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function saveOnClick() {
        const source = window.atob(props.selectedSubId).split(":").pop();

        if (!isNewFolder) {
            const parentFolder = window.atob(selectedParentId).split(":").pop();
            console.log("Parent: " + parentFolder);
            console.log("Source: " + source);
            console.log("Sub Name: " + props.selectedSubName);

            if (parentFolder) {
                AddSubscriptionMutation(
                    selectedSubName,
                    parentFolder,
                    source,
                    () => {
                        console.log("Added a new subscription!");
                    }
                );
                props.setIsModalActive(false);
            } else {
                setStatusMessage("Select a folder or create a new one!");

            }
        } else {
            // Add Folder name validation.
            if (validateString(enteredFolderName)) {
                let promise = new Promise(function (resolve, reject) {
                    AddFolderMutation(enteredFolderName, (newFolderId) => {
                        resolve(newFolderId);
                    });
                });
                promise.then(
                    (newFolderId) => {
                        let parentFolder = window
                            .atob(newFolderId)
                            .split(":")
                            .pop();
                        // let source = window.atob(props.selectedSubId).split(":").pop();
                        AddSubscriptionMutation(
                            selectedSubName,
                            parentFolder,
                            source,
                            () => {
                                // console.log("Added a new subscription!");
                            }
                        );
                    },
                    (folderId) => {}
                );
                props.setIsModalActive(false);
            }
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        saveOnClick();
    }

    function onFolderNameChange(e) {
        e.preventDefault();
        setEnteredFolderName(e.target.value);
    }

    useEffect(() => {});

    function onNewFolderClick(e) {
        setIsNewFolder(true);
    }

    function onChangeButton(e) {
        setIsNewFolder(false);
        const parentBase64 = e.target.value;
        setSelectedParentId(parentBase64);
        setStatusMessage("");
    }

    function validateString(value) {
        if (value == "") {
            setStatusMessage("Folder name cannot be empty!");
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            <Modal
                style={style}
                title={"Add Source"}
                isModalActive={props.isModalActive}
                setIsModalActive={props.setIsModalActive}
            >
                <div
                    className={`theme-${theme.paragraph} add-source-modal-contents`}
                >
                    <form className="add-source-modal-form" onSubmit={onSubmit}>
                        <div className="add-source-inputs">
                            <div>
                                <label
                                    className={`theme-${theme.paragraph} source-name-heading`}
                                >
                                    Select Folder
                                </label>

                                <label
                                    className={`theme-${theme.paragraph} source-name-label`}
                                >
                                    Source: {props.selectedSubName}
                                </label>
                            </div>
                            <div className={`xsource-select-container`}>
                                <div className={`source-container`}>
                                    <div>
                                        <div className="button-select-container">
                                            {user_Subscription.edges.map(
                                                (edge, key) =>
                                                    edge.node.parent ? null : (
                                                        <div
                                                            className="button-select-btn"
                                                            key={edge.node.id}
                                                        >
                                                            <label
                                                                htmlFor={
                                                                    "btn" +
                                                                    edge.node.id
                                                                }
                                                            >
                                                                <input
                                                                    onChange={
                                                                        onChangeButton
                                                                    }
                                                                    name="folder"
                                                                    type="radio"
                                                                    id={
                                                                        "btn" +
                                                                        edge
                                                                            .node
                                                                            .id
                                                                    }
                                                                    value={
                                                                        edge
                                                                            .node
                                                                            .id
                                                                    }
                                                                    data-name={
                                                                        edge
                                                                            .node
                                                                            .name
                                                                    }
                                                                />
                                                                <span>
                                                                    {
                                                                        edge
                                                                            .node
                                                                            .name
                                                                    }
                                                                </span>
                                                            </label>
                                                        </div>
                                                    )
                                            )}
                                        </div>

                                        <span
                                            onClick={onNewFolderClick}
                                            className="add-folder-button-container"
                                        >
                                            <Add20 className="folder-add-icon" />
                                            <span className="add-folder-button">
                                                NEW FOLDER
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                {isNewFolder ? (
                                    <div className="new-folder-input-container">
                                        <label>Name</label>
                                        <input
                                            onChange={onFolderNameChange}
                                            className="standard-textfield-small"
                                            type="text"
                                        />
                                    </div>
                                ) : null}
                            </div>

                                <InlineNotification
                                    message={statusMessage}
                                    isActive={true}
                                />
                        </div>

                        <div className="add-source-controls btn-group">
                            {" "}
                            <input
                                onClick={onCancelClick}
                                className="standard-action-button"
                                type="button"
                                value="Cancel"
                            />
                            <input
                                className="standard-action-button"
                                type="submit"
                                value="Save"
                            />
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
}

export default createFragmentContainer(AddSourceModal, {
    user_Subscription: graphql`
        fragment AddSourceModal_user_Subscription on SubscriptionNodeConnection {
            edges {
                node {
                    id
                    name
                    parent {
                        id
                    }
                }
            }
        }
    `,
});
